import protoRoot from "../proto-root";
import CameraEvent from "./CameraEvent";

function create({ recordingOn, recordingOff }: CameraRecordingStatus) {
  const CameraVideoRecordingStatus = protoRoot.lookupType("comm.CameraVideoRecordingStatus");
  const RecordingOn = CameraVideoRecordingStatus.lookupType("RecordingOn");
  const RecordingOff = CameraVideoRecordingStatus.lookupType("RecordingOff");

  if (recordingOn) {
    return CameraVideoRecordingStatus.create({
      recordingOn: RecordingOn.create({
        recordingStart: recordingOn.recordingStart,
        recordingEnd: recordingOn.recordingEnd,
        event: recordingOn.event ? CameraEvent.create(recordingOn.event) : undefined
      })
    });
  } else {
    return CameraVideoRecordingStatus.create({
      recordingOff: RecordingOff.create({
        event: recordingOff?.event ? CameraEvent.create(recordingOff.event) : undefined
      })
    });
  }
}

const cameraRecordingStatus = { create };

export default cameraRecordingStatus;
